import { render, staticRenderFns } from "./ItemGroups.vue?vue&type=template&id=a0c0570c&scoped=true&lang=html&"
import script from "./ItemGroups.vue?vue&type=script&lang=js&"
export * from "./ItemGroups.vue?vue&type=script&lang=js&"
import style0 from "./ItemGroups.vue?vue&type=style&index=0&id=a0c0570c&prod&lang=css&"
import style1 from "./ItemGroups.vue?vue&type=style&index=1&id=a0c0570c&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c0570c",
  null
  
)

export default component.exports